import React from 'react';
import Avatar from '@atlaskit/avatar';
import { Box, xcss } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import type { AssociatedIssue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/associated-issues/types.tsx';

const Issue = (props: { data: AssociatedIssue }) => (
	<Box xcss={container}>
		<Box xcss={fg('migrate_plan_filter_to_popup') ? avatar : avatarOld}>
			<Avatar src={props.data.iconUrl} size="xsmall" />
		</Box>
		<Box xcss={summary}>{props.data.summary}</Box>
	</Box>
);

export const AssociatedIssuesView = (props: { associatedIssues: AssociatedIssue[] }) => (
	<div>
		{props.associatedIssues.map((associatedIssue) => (
			<Issue key={associatedIssue.key} data={associatedIssue} />
		))}
	</div>
);

const container = xcss({
	display: 'flex',
	alignItems: 'center',
	paddingInlineEnd: 'space.100',
	height: '100%',
});

const avatarOld = xcss({
	paddingInlineEnd: 'space.050',
	flexShrink: 0,
});

const avatar = xcss({
	paddingInlineEnd: 'space.050',
	flexShrink: 0,
	display: 'flex',
});

const summary = xcss({
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	flexBasis: 'content',
	flexShrink: 1,
});
